import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { TABS } from './tabs'

type TabId = (typeof TABS)[keyof typeof TABS]

/**
 * Legacy `/accounts#…` anchors, still linked from emails, help-centre articles and
 * several in-app surfaces. Each resolves to the tab that now owns the content.
 */
const LEGACY_HASH_TARGETS: Record<string, TabId> = {
  '#connected-institutions': TABS.FINANCIAL_INSTITUTIONS,
  '#reactivation': TABS.PLAN_AND_BILLING,
}

export const useLegacyHashTab = (
  fallbackTab: TabId,
  validIds: readonly string[]
) => {
  const navigate = useNavigate()
  const { pathname, search, hash } = useLocation()

  const target = LEGACY_HASH_TARGETS[hash]

  const resolvedTab = target && validIds.includes(target) ? target : fallbackTab

  useEffect(() => {
    if (target && hash && new URLSearchParams(search).has('tab')) {
      navigate({ pathname, search }, { replace: true })
    }
  }, [target, hash, navigate, pathname, search])

  return resolvedTab
}
